




















import Vue from 'vue'
import Component from 'vue-class-component'
import Service from '@/modules/reservation/model/Service'
import {Action, State} from 'vuex-class'
import {Prop} from 'vue-property-decorator'
import DepartmentType from '@/modules/reservation/model/DepartmenType'

/**
 * Selector de servicios
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ServiceSelect extends Vue {
    /**
     * Etiqueta para el control
     */
    @Prop({type: String, default: 'Seleccionar servicios'})
    public label: string

    /**
     * Servicios seleccionados
     */
    @Prop({type: Array, default: () => ([])})
    public value: Service[]

    @Prop({type: DepartmentType, default: null})
    public departmentType: DepartmentType | null

    @Prop({type: Boolean, default: false})
    public dense: boolean

    public get services (): Service[] {
        if (this.departmentType) {
            return this.departmentType.availableServices
        }

        return this.$store.state.reservation.services
    }

    public get noDataText () {
        switch (true) {
            case this.loading:
                return 'Cargando lista de servicios'
            case this.departmentType && !this.departmentType.id:
                return 'No se ha seleccionado ningún tipo con servicios'
            case this.departmentType && !this.departmentType.availableServices.length:
                return `${this.departmentType!.name} no tiene servicios disponibles`
            case !this.departmentType:
                return 'No se han registrado servicios de reservar'
            default:
                return 'No existen servicios'
        }
    }

    /**
     * Carga la lista de servicios
     */
    @Action('reservation/loadServicesList')
    public loadServices: (options?: {force?: boolean}) => void

    public loading = true

    public async created () {
        // El componente mostrará solo los servicios disponibles para el tipo de departamento
        if (this.departmentType) {
            this.loading = false
            return
        }

        await this.loadServices()
        this.loading = false
    }
}
